import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/cashback';
import {claimCashback} from '../../../reducers/app/actions';

const format = (time, short = false) => {
    const days = Math.floor(time / (24 * 60 * 60 * 1e3));
    time -= days * (24 * 60 * 60 * 1e3);

    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / (60 * 1e3));
    time -= minutes * (60 * 1e3);

    const seconds = Math.floor(time / 1e3);

    let string = ``;

    if(days > 0) string += `${days}d `;
    if(hours > 0) string += `${hours}h `;
    if(minutes > 0) string += `${minutes}m `;
    if(!short) string += `${seconds}s `;

    return string.trim();
}

export default ({task_key, timeout, short=false, activeClass, inactiveClass, balance}) => {
    const [time, setTime] = useState(timeout - Date.now()),
          {button} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        window[`${task_key}_timeout`] = setTimeout(() => setTime(time - 500), 500);
        return () => clearTimeout(window[`${task_key}_timeout`])
    }, [time]);

    if(time <= 0)
        return (
            <div className={!button ? activeClass : inactiveClass} onClick={e => {
                if(button)
                    return;

                dispatch(claimCashback());
            }}>Claim <span>${balance}</span></div>
        )

    return <div className={inactiveClass}><span>{format(time, short)}</span></div>
}